import { api } from "../../axios";
export const actions = {
    //Faculty
    GetAllFaculties() {
        return api.get(`Faculty/All`);
      },
    GetFaculties() {
      return api.get(`Faculty/My`);
    },
    GetAvailableFaculties() {
        return api.get(`Faculty/Available`);
    },
    GetFacultyByDU(context, data) {
        return api.get(`Faculty/DeliveryUnit/${data}`);
    },
    GetSingleFaculty(context, data) {
        return api.get(`Faculty/${data}`);
    },
    AddSingleFaculty(context, data) {
        return api.post(`Faculty/Add`, data);
    },
    AddMultipleFaculty(context, data) {
        return api.post(`Faculty/Add/Multiple`, data);
    },
    UpdateFaculty(context, data) {
        return api.put(`Faculty/${data.id}`, data);
    },
    DeleteFaculty(context, data) {
        return api.delete(`Faculty/${data}`);
    },
}